

deleteItemController = ($state, ChangeLogService, changeLogItem) ->
    'ngInject'

    @item = changeLogItem
    console.log @item.title

    @confirm = ->
        return ChangeLogService.delete(changeLogItem)
            .then -> $state.go('changeLog.list')

    return


state = 
    url: '/delete'
    templateUrl: 'changeLog/delete'
    controllerAs: 'ctrl'
    controller: deleteItemController


stateConfig = ($stateProvider) ->
    'ngInject'

    $stateProvider.state 'changeLog.item.delete', state

    return 


module.config stateConfig
